var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _rect7, _rect8, _rect9, _rect0, _circle, _circle2, _circle3, _circle4, _path8, _path9, _path0, _path1, _path10, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path11, _path12, _path13, _path14, _path15, _path16, _rect15, _rect16, _rect17, _rect18, _circle5, _circle6, _circle7, _circle8, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 213,
    viewBox: "0 0 240 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M231.618 133.236C231.618 133.236 273.881 26.2641 162.629 24.7648C51.376 23.2656 0.507308 39.6875 0.00467844 94.0919C-0.497951 148.496 39.5731 199.339 109.411 199.902C179.25 200.466 217.016 179.997 231.618 133.236Z",
    fill: "#D4DBE0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.9844,
    y: 12.3522,
    width: 160.574,
    height: 185.522,
    rx: 7.29167,
    transform: "rotate(1 45.9844 12.3522)",
    fill: "white",
    stroke: "#D4DBE0",
    strokeWidth: 2.08333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7615,
    y: 29.2219,
    width: 19.1597,
    height: 5.7479,
    rx: 2.87395,
    transform: "rotate(1 72.7615 29.2219)",
    fill: "#54708C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3158,
    y: 146.229,
    width: 111.126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(1 67.3158 146.229)",
    fill: "#54708C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0812,
    y: 159.639,
    width: 111.126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(1 67.0812 159.639)",
    fill: "#54708C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8472,
    y: 173.048,
    width: 79.5126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(1 66.8472 173.048)",
    fill: "#54708C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5391,
    y: 46.0396,
    width: 130.725,
    height: 0.997899,
    transform: "rotate(1 69.5391 46.0396)",
    fill: "#EAEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3745 136.928L86.4674 136.982L86.5579 131.796L88.8151 131.835L91.4961 137.07L94.9104 137.129L91.9025 131.389C93.5792 130.704 94.526 129.27 94.5609 127.27C94.6116 124.363 92.7228 122.458 89.4014 122.4L83.6299 122.299L83.3745 136.928ZM86.6013 129.31L86.6786 124.882L88.7644 124.918C90.5501 124.949 91.4006 125.757 91.3751 127.214C91.3498 128.664 90.4728 129.378 88.7014 129.347L86.6013 129.31Z",
    fill: "#54708C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5747 137.158L106.461 137.331L106.505 134.781L99.7121 134.662L99.7731 131.169L106.03 131.279L106.075 128.728L99.8176 128.619L99.8784 125.134L106.643 125.252L106.687 122.702L96.8301 122.529L96.5747 137.158Z",
    fill: "#54708C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.891 137.373L111.984 137.427L112.067 132.684L114.667 132.73C118.031 132.788 120.023 130.815 120.074 127.894C120.125 124.987 118.239 122.903 114.918 122.845L109.146 122.744L108.891 137.373ZM112.11 130.206L112.195 125.327L114.281 125.363C116.067 125.395 116.914 126.381 116.888 127.838C116.863 129.288 115.981 130.273 114.21 130.242L112.11 130.206Z",
    fill: "#54708C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.485 130.521C135.569 125.735 132.645 122.955 128.766 122.887C124.866 122.819 121.868 125.496 121.785 130.282C121.702 135.046 124.604 137.848 128.504 137.916C132.382 137.983 135.402 135.307 135.485 130.521ZM132.349 130.466C132.295 133.566 130.794 135.219 128.552 135.18C126.302 135.141 124.867 133.436 124.921 130.336C124.975 127.236 126.468 125.583 128.718 125.623C130.961 125.662 132.403 127.366 132.349 130.466Z",
    fill: "#54708C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.649 137.875L140.741 137.929L140.832 132.743L143.089 132.783L145.77 138.017L149.184 138.077L146.176 132.337C147.853 131.651 148.8 130.217 148.835 128.217C148.886 125.31 146.997 123.405 143.675 123.347L137.904 123.246L137.649 137.875ZM140.875 130.258L140.953 125.829L143.038 125.865C144.824 125.897 145.675 126.705 145.649 128.162C145.624 129.612 144.747 130.325 142.975 130.294L140.875 130.258Z",
    fill: "#54708C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.502 126.017L154.981 126.095L154.77 138.174L157.827 138.227L158.038 126.149L162.517 126.227L162.561 123.677L150.547 123.467L150.502 126.017Z",
    fill: "#54708C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 144.342,
    y: 63.2583,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(1 144.342 63.2583)",
    fill: "#00274D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 144.158,
    y: 73.7944,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(1 144.158 73.7944)",
    fill: "#54708C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 143.991,
    y: 83.3728,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(1 143.991 83.3728)",
    fill: "#BFBFBF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 143.824,
    y: 92.9512,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(1 143.824 92.9512)",
    fill: "#BC7B7B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.23,
    cy: 64.5887,
    r: 3.35294,
    transform: "rotate(1 138.23 64.5887)",
    fill: "#00274D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.046,
    cy: 75.1248,
    r: 3.35294,
    transform: "rotate(1 138.046 75.1248)",
    fill: "#54708C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.879,
    cy: 84.7032,
    r: 3.35294,
    transform: "rotate(1 137.879 84.7032)",
    fill: "#BFBFBF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.712,
    cy: 94.2816,
    r: 3.35294,
    transform: "rotate(1 137.712 94.2816)",
    fill: "#BC7B7B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.232 79.1194L124.085 88.1665C125.084 85.5842 125.652 82.8212 125.788 79.9639C125.99 73.3815 123.58 67.4468 119.413 62.9545L102.232 79.1194Z",
    fill: "#BC7B7B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.339 77.9947L118.904 62.339C116.095 59.4303 112.492 57.2877 108.527 56.0919L106.031 65.0607L102.339 77.9947Z",
    fill: "#00274D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.653 55.0362L102.025 76.0828L107.752 55.8184C106.112 55.4432 104.384 55.153 102.653 55.0362Z",
    fill: "#00274D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.107 79.0131L101.786 55.021C88.6169 54.8778 77.6888 65.3459 77.2842 78.5973C77.1219 82.9273 78.1771 87.0186 80.0224 90.517L101.107 79.0131Z",
    fill: "#54708C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.853 103.533C111.074 103.798 119.931 97.7995 123.812 88.9416L101.529 79.7137L80.4438 91.2176C84.4781 98.3939 92.0199 103.205 100.853 103.533Z",
    fill: "#BFBFBF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4653,
    y: 29.0901,
    width: 160.574,
    height: 185.522,
    rx: 7.29167,
    transform: "rotate(-10 29.4653 29.0901)",
    fill: "white",
    stroke: "#D4DBE0",
    strokeWidth: 2.08333
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9685,
    y: 40.5405,
    width: 19.1597,
    height: 5.7479,
    rx: 2.87395,
    transform: "rotate(-10 58.9685 40.5405)",
    fill: "#54708C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9489,
    y: 156.437,
    width: 111.126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(-10 75.9489 156.437)",
    fill: "#54708C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 78.2773,
    y: 169.645,
    width: 111.126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(-10 78.2773 169.645)",
    fill: "#54708C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6064,
    y: 182.853,
    width: 79.5126,
    height: 7.66386,
    rx: 3.83193,
    transform: "rotate(-10 80.6064 182.853)",
    fill: "#54708C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0142,
    y: 57.6643,
    width: 130.725,
    height: 0.997899,
    transform: "rotate(-10 59.0142 57.6643)",
    fill: "#EAEDF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.938 144.243L92.9844 143.705L92.0837 138.598L94.3069 138.206L97.9374 142.832L101.3 142.239L97.2524 137.179C98.7676 136.186 99.4234 134.598 99.076 132.628C98.5711 129.764 96.3535 128.255 93.082 128.832L87.3973 129.834L89.938 144.243ZM91.652 136.149L90.8829 131.787L92.9372 131.425C94.6961 131.115 95.6851 131.746 95.9382 133.181C96.19 134.609 95.4653 135.477 93.7205 135.785L91.652 136.149Z",
    fill: "#54708C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.94 141.95L112.677 140.233L112.234 137.721L105.543 138.901L104.936 135.461L111.1 134.374L110.657 131.862L104.494 132.949L103.888 129.516L110.551 128.341L110.108 125.829L100.399 127.541L102.94 141.95Z",
    fill: "#54708C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.071 139.811L118.117 139.274L117.293 134.602L119.854 134.151C123.168 133.566 124.747 131.25 124.24 128.372C123.735 125.509 121.486 123.823 118.215 124.4L112.53 125.402L115.071 139.811ZM116.863 132.161L116.015 127.356L118.07 126.994C119.829 126.683 120.849 127.49 121.102 128.925C121.354 130.354 120.676 131.489 118.931 131.796L116.863 132.161Z",
    fill: "#54708C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.869 128.01C139.037 123.296 135.637 121.125 131.817 121.798C127.975 122.476 125.543 125.676 126.375 130.39C127.202 135.082 130.585 137.279 134.427 136.601C138.247 135.928 140.7 132.724 139.869 128.01ZM136.78 128.555C137.318 131.608 136.161 133.517 133.951 133.907C131.735 134.297 130.001 132.898 129.463 129.845C128.925 126.792 130.075 124.884 132.292 124.493C134.501 124.104 136.242 125.501 136.78 128.555Z",
    fill: "#54708C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.396 134.817L146.442 134.279L145.541 129.172L147.765 128.78L151.395 133.406L154.758 132.813L150.71 127.752C152.225 126.76 152.881 125.172 152.534 123.202C152.029 120.338 149.811 118.829 146.54 119.406L140.855 120.408L143.396 134.817ZM145.11 126.723L144.34 122.361L146.395 121.999C148.154 121.689 149.143 122.32 149.396 123.755C149.648 125.183 148.923 126.051 147.178 126.359L145.11 126.723Z",
    fill: "#54708C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.751 120.724L158.162 119.946L160.26 131.843L163.271 131.312L161.173 119.415L165.584 118.637L165.142 116.125L153.308 118.212L153.751 120.724Z",
    fill: "#54708C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 135.729,
    y: 60.2932,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(-10 135.729 60.2932)",
    fill: "#00274D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 137.559,
    y: 70.6709,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(-10 137.559 70.6709)",
    fill: "#54708C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 139.223,
    y: 80.1052,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(-10 139.223 80.1052)",
    fill: "#BFBFBF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 140.885,
    y: 89.5393,
    width: 21.0756,
    height: 2.87395,
    rx: 1.43697,
    transform: "rotate(-10 140.885 89.5393)",
    fill: "#BC7B7B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.983,
    cy: 62.7654,
    r: 3.35294,
    transform: "rotate(-10 129.983 62.7654)",
    fill: "#00274D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.812,
    cy: 73.1431,
    r: 3.35294,
    transform: "rotate(-10 131.812 73.1431)",
    fill: "#54708C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.476,
    cy: 82.5774,
    r: 3.35294,
    transform: "rotate(-10 133.476 82.5774)",
    fill: "#BFBFBF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.14,
    cy: 92.0118,
    r: 3.35294,
    transform: "rotate(-10 135.14 92.0118)",
    fill: "#BC7B7B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.419 83.8983L120.597 88.6094C121.084 85.8841 121.114 83.0634 120.703 80.2325C119.645 73.7326 116.148 68.3667 111.199 64.7522L97.419 83.8983Z",
    fill: "#BC7B7B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3088 82.7739L110.582 64.2452C107.27 61.9259 103.325 60.5099 99.2042 60.0928L98.4651 69.373L97.3088 82.7739Z",
    fill: "#00274D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2361 60.1773L96.6362 80.957L98.3908 59.9723C96.7094 59.9168 94.9577 59.9618 93.2361 60.1773Z",
    fill: "#00274D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2944 84.0086L92.3828 60.3278C79.4281 62.7 70.6982 75.0609 72.8295 88.1461C73.4964 92.4275 75.3128 96.2423 77.7918 99.3243L96.2944 84.0086Z",
    fill: "#54708C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.723 108.126C110.807 106.436 118.357 98.8581 120.476 89.4225L96.8418 84.6159L78.3392 99.9317C83.6686 106.206 91.9898 109.49 100.723 108.126Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectReport);
export default __webpack_public_path__ + "static/media/select-report.9bcb75249943bfcdef75636cc428933b.svg";
export { ForwardRef as ReactComponent };